import axios from 'axios';

export default {
    getGroup(context, queryParams) {
        let url = window.apiUrl + '/mentor-group';

        if (queryParams && queryParams.length > 0) {
            url = url + '?';
            queryParams.forEach((param)=> {
                url += param + '=true&';
            });
        }
        
        var options = {
            url: url,
            method: 'GET',           
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getMentees() {
        const options = {
            url: window.apiUrl + '/mentees',            
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET',
        }

        return axios.request(options).then(function(response) {
            return response;

        }).catch(function(error) {
            console.log(error)
            return (error);
        });
    },
    getProfile(context, id) {
        var options = {
            url: window.apiUrl + '/mentor-profile/' + id,
            method: 'GET',           
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    updateProfile(context, data) {
        var options = {
            url: window.apiUrl + '/mentor-profile',
            method: 'PATCH',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    deleteItem(context, type, item) {
        var options = {
            url: window.apiUrl + '/mentor-profile-item',
            method: 'DELETE',           
            data: {type: type, item: item},
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    get(context, termId) {
        let url = window.apiUrl + '/mentors';
        if (termId) {
            url = url + '?term_id=' + termId;
        }
        var options = {
            url: url,
            method: 'GET',           
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

    request(context, data) {
        var options = {
            url: window.apiUrl + '/mentor-request',
            method: 'POST',           
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getRequests(context) {
        var options = {
            url: window.apiUrl + '/mentor-requests',
            method: 'GET',           
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    reassign(context, data) {
        var options = {
            url: window.apiUrl + '/reassign-request',
            method: 'PATCH',           
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    updateRequest(context, id, status) {
        var options = {
            url: window.apiUrl + '/mentor-request',
            method: 'PATCH',           
            data: {id: id, status: status},
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    togglePublic(data) {
        var options = {
            url: window.apiUrl + '/mentor-profile?toggle_public=true',
            method: 'PATCH',           
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    addTask(context, task) {
       var options = {
            url: window.apiUrl + '/mentor-task',
            method: 'POST',           
            data: task,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    deleteTask(context, id) {
       var options = {
            url: window.apiUrl + '/mentor-task/' + id,
            method: 'DELETE',           
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    updateTask(context, task) {
       var options = {
            url: window.apiUrl + '/mentor-task',
            method: 'PATCH',           
            data: task,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    getSoftware() {
        var options = {
            url: window.apiUrl + '/mentor-software',
            method: 'GET',           
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getSkills() {
        var options = {
            url: window.apiUrl + '/mentor-skills',
            method: 'GET',           
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/mentors/index.js